/*eslint-disable */
define(function (require) {
  var $ = require("jquery");
  var scrollto = require("common/util/scrollto");
  var GiftCardBookingView = require("./view/gift-card-booking");
  require("modernizr");

  function initialize(options) {
    const quantity = document.getElementById("gift-card-quantity");
    const message = document.querySelector(".whn-gift-card-message");
    const email = document.querySelector(".whn-gift-card-email");

    const toggleHasValueClass = (target, value) => {
      target.classList.toggle(
        "gift-card-form__field--has-value",
        value.trim() !== ""
      );
    };

    initialiseLinkScrolling();

    options = options || {};
    options.account = options.account === undefined ? true : false;

    new GiftCardBookingView({ el: $(".whn-gift-card-booking") });

    document
      .querySelector(".gift-card-form__step--down .gift-card-button")
      .addEventListener("click", () => {
        quantity.stepDown();
      });

    document
      .querySelector(".gift-card-form__step--up .gift-card-button")
      .addEventListener("click", () => {
        quantity.stepUp();
      });

    document
      .getElementById("gift-card-message")
      .addEventListener("change", (e) => {
        toggleHasValueClass(message, e.target.value);
      });

    document
      .getElementById("gift-card-email")
      .addEventListener("change", (e) => {
        toggleHasValueClass(email, e.target.value);
      });
  }

  function initialiseLinkScrolling() {
    $(".gift-card-button[data-href]").click(function () {
      var $link = $(this);
      var target = $link.data("href");
      var $target = $(target);

      if (Modernizr.history) {
        history.pushState(null, null, target);
      }

      scrollto($target);
    });
  }

  initialize();
});
